import { AlertTriangle } from "lucide-react";

/**
 * Persistent, subtle strip at the bottom of every authenticated page.
 * Hidden on print via `print:hidden`.
 */
export default function DisclaimerBar() {
  return (
    <div
      data-testid="ai-disclaimer-bar"
      className="print:hidden fixed bottom-0 left-0 right-0 z-40 bg-primary/95 text-primary-foreground text-[11px] tracking-wide flex items-center justify-center gap-2 px-4 py-1.5 shadow-[0_-2px_8px_rgba(0,0,0,0.08)]"
    >
      <AlertTriangle className="w-3.5 h-3.5" />
      <span>
        AI may make mistakes — please check before finalising any proposal, publication, or client-facing document.
      </span>
    </div>
  );
}
